export default __webpack_public_path__ + "static/media/hub-icon.897d7958.svg";